var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.9997 25.3333V5.33325",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M19.9997 18.6667V27.8619",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M28 17.3335V24.443C28.0012 25.0161 27.6351 25.5254 27.0914 25.7068C25.3616 26.2835 21.6568 27.5186 20.4153 27.9327C20.1435 28.0233 19.8495 28.0226 19.5781 27.9306L12.4217 25.5448C12.148 25.4536 11.852 25.4536 11.5783 25.5448L5.75501 27.4862C5.34841 27.6217 4.90144 27.5535 4.55374 27.3029C4.20604 27.0523 4 26.6499 4 26.2213V8.81717C4 8.24328 4.36722 7.73378 4.91165 7.55228L11.1566 5.47036C11.704 5.28787 12.2959 5.28787 12.8433 5.47036L14.6667 6.07819",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M18.667 8.66675C18.667 10.8514 21.051 13.1852 22.411 14.3392C22.9481 14.7759 23.7179 14.7759 24.255 14.3392C25.6163 13.1852 28.0003 10.8514 28.0003 8.66675",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M23.335 8.33334C23.5189 8.33408 23.6675 8.48364 23.667 8.66756C23.6665 8.85148 23.5171 9.00025 23.3332 9.00001C23.1493 8.99976 23.0003 8.8506 23.0003 8.66668C22.9999 8.57789 23.035 8.49263 23.0979 8.42998C23.1608 8.36733 23.2462 8.33252 23.335 8.33334",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M18.667 8.66667V8.66667C18.667 6.08934 20.7563 4 23.3337 4V4C25.911 4 28.0003 6.08934 28.0003 8.66667V8.66667",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationReview);
export default __webpack_public_path__ + "static/media/locationReview.2a03561bbd1b8925201ab493ba9d53e3.svg";
export { ForwardRef as ReactComponent };